import { render } from "./footer.vue?vue&type=template&id=7f65325b&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"

import "./footer.vue?vue&type=style&index=0&id=7f65325b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7f65325b"

export default script